import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import RouteContent from '../internal/RouteContent';

function PublicRoute(_ref) {
  var children = _ref.children,
      component = _ref.component,
      exact = _ref.exact,
      layout = _ref.layout,
      location = _ref.location,
      path = _ref.path,
      _render = _ref.render,
      sensitive = _ref.sensitive,
      showIf = _ref.showIf,
      strict = _ref.strict,
      rest = _objectWithoutProperties(_ref, ["children", "component", "exact", "layout", "location", "path", "render", "sensitive", "showIf", "strict"]);

  return React.createElement(Route, {
    exact: exact,
    location: location,
    path: path,
    sensitive: sensitive,
    strict: strict,
    render: function render(routeProps) {
      return React.createElement(RouteContent, _extends({}, rest, routeProps, {
        render: _render,
        component: component,
        layout: layout,
        showIf: showIf
      }), children);
    }
  });
}

PublicRoute.propTypes = {
  /**
   * Render children funkce ve formatu `(props: Object) => Node`
   */
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /**
   * Komponenta, ktera je renderovane pri splneni podminek path,
   * ComponentType<any>
   */
  component: PropTypes.elementType,

  /**
   * Path exact match.
   */
  exact: PropTypes.bool,

  /**
   * Komponeta layoutu. Pokud je definovana, obsah je wrapnut do layoutu.
   *
   * ComponentType<{}>
   */
  layout: PropTypes.elementType,
  location: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /**
   * Cesta
   */
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /** (props: Object) => Node */
  render: PropTypes.func,

  /**
   * (props) => Node
   */
  renderNotFound: PropTypes.func,
  sensitive: PropTypes.bool,
  showIf: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.func]),
  strict: PropTypes.bool
};
PublicRoute.defaultProps = {
  children: null,
  component: undefined,
  exact: false,
  layout: undefined,
  location: undefined,
  path: undefined,
  render: undefined,
  renderNotFound: PropTypes.func,
  sensitive: undefined,
  showIf: true,
  strict: false
};
export default PublicRoute;